import { createStore } from 'vuex'
import { get } from 'lodash'

export default createStore({
    state() {
        return {
            user: {
                first_name: get(window.user, 'first_name'),
                last_name: get(window.user, 'last_name'),
                email: get(window.user, 'email'),
            },
            notification: {
                text: get(window.notification, 'text'),
                type: get(window.notification, 'type'),
            },
        }
    },
    mutations: {
        updateUser(state, user) {
            state.user.first_name = user.first_name
            state.user.last_name = user.last_name
            state.user.email = user.email
        },
        setNotification(state, notification) {
            state.notification.type = notification.type
            state.notification.text = notification.text
        },
    },
    actions: {
        clearNotification({ commit }) {
            commit('setNotification', {
                text: '',
                type: '',
            })
        },
    },
})
